module.exports = {"apiUrl":"http://localhost:4000/local","server":"LOCAL_SERVER","NODE_ENV":"production"};